// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox--23OsqqyZ9T","dark":"dark--1UK4eHwUJ1","light":"light--9aKExahegY"};